import React from 'react';
import { CalendarOff } from 'lucide-react';
import { colorForDoctor, doctorDisplayName } from './doctorColors';

export default function DoctorPanel({
  doctors = [],
  appointmentCounts = {}, // { doctorId: number, all: number }
  selectedDoctorId,
  onSelect,
  onBlockCalendar,
  categories = [],
}) {
  return (
    <aside className="cal-left">
      <button className="cal-block-btn" onClick={onBlockCalendar}>
        <CalendarOff size={16} /> Block Calendar
      </button>

      <div className="cal-section-label">Doctors</div>
      <div className="cal-doc-list">
        <button
          className={`cal-doc ${selectedDoctorId == null ? 'active' : ''}`}
          onClick={() => onSelect(null)}
        >
          <span className="cal-doc-dot" style={{ background: '#cbd5e1' }} />
          <span className="cal-doc-name">All doctors</span>
          <span className="cal-doc-count">{appointmentCounts.all ?? 0}</span>
        </button>
        {doctors.map((d) => {
          const color = colorForDoctor({ id: d.id, colorTag: d.colorTag });
          const active = selectedDoctorId === d.id;
          return (
            <button
              key={d.id}
              className={`cal-doc ${active ? 'active' : ''}`}
              onClick={() => onSelect(d.id)}
              title={d.email || d.fullName}
            >
              <span className="cal-doc-dot" style={{ background: color.dot }} />
              <span className="cal-doc-name">{doctorDisplayName(d.fullName)}</span>
              <span className="cal-doc-count">{appointmentCounts[d.id] ?? 0}</span>
            </button>
          );
        })}
        {doctors.length === 0 && (
          <div style={{ padding: '12px 16px', fontSize: '0.78rem', color: 'var(--text-muted)' }}>
            No doctors yet. Add staff with the Doctor role to see them here.
          </div>
        )}
      </div>

      {categories.length > 0 && (
        <>
          <div className="cal-section-label" style={{ marginTop: 12 }}>
            Categories <span className="cal-section-edit">EDIT</span>
          </div>
          <div className="cal-doc-list">
            <button className="cal-doc">
              <span className="cal-doc-dot" style={{ background: 'transparent' }} />
              <span className="cal-doc-name">All appointments</span>
            </button>
            {categories.map((c) => (
              <button key={c.id} className="cal-doc">
                <span className="cal-doc-dot" style={{ background: c.color || '#3b82f6' }} />
                <span className="cal-doc-name">{c.name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </aside>
  );
}
